module.exports = __webpack_public_path__ + "media/images/default_logo-76ce3c4c4bd5a45c997b8e97f21f8c5e.png";